import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Modal } from '@/ui/modal/modal';
import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Stack } from '@/ui/line/line';
import { modalState } from '@/state/modal.state';
import { useSetAtom } from 'jotai';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  accountName: string;
  previousAccountName: string;
  entityType: string;
}

export const AccountSwitchNotificationModal = ({
  isOpen,
  accountName,
  previousAccountName,
  entityType,
}: Props) => {
  const { t } = useTranslation('account-switch');
  const setModal = useSetAtom(modalState);

  const handleClose = () => {
    setModal(null);
  };

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal onClose={handleClose} header={t('notification.header')}>
      <Stack gap="20px">
        <div>
          <Trans
            i18nKey="notification.message"
            ns="account-switch"
            values={{
              accountName,
              previousAccountName,
              entityType,
            }}
            components={{ strong: <strong /> }}
          />
        </div>
        <Flexbox justify="flex-end">
          <Button variant="primary" onClick={handleClose}>
            {t('notification.dismissButton')}
          </Button>
        </Flexbox>
      </Stack>
    </Modal>
  );
};
